import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import ImageResponsive from "../../Image/ImageResponsive";
import { ImageFit } from "../../Image/interface/ImageData";
import {
  _LandingPacmanHeaderContainer,
  _LandingPacmanRoot,
} from "./LandingPacman.styled";
import Button from "design-system/src/Foundation/Button/Button";
import FlexBox from "../../FlexBox/FlexBox";
import HighlightedTypography from "../../HighlightedTypography/HighlightedTypography";
import Typography from "../../../Foundation/Typography/Typography";
import htmlParse from "html-react-parser";

export interface IPacmanGameData {
  score: number;
  pseudo: string;
  pictoID: string;
}

interface ILandingPacmanProps {
  url: string;
  poster: {
    desktop: string;
    mobile: string;
  };
  aspectRatio?: number;
  style?: React.CSSProperties;
  onFinished?: (data: IPacmanGameData) => void;
  onError?: () => void;
  playLabel?: string;
  highlightedTitle?: string;
  title: string;
  description?: string;
}

const LandingPacman = (props: ILandingPacmanProps) => {
  const {
    url,
    poster,
    aspectRatio = 21 / 9,
    style,
    onFinished,
    onError,
    playLabel = "Jouer",
    highlightedTitle,
    title,
    description = "",
  } = props;
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [showPlayer, setShowPlayer] = useState(false);

  const handlePlay = () => {
    setShowPlayer(true);
    // setTimeout(() => {
    //   iframeRef.current?.internalPlayer?.playVideo();
    // }, 1000);
  };

  useEffect(() => {
    const handleMessage = (event: MessageEvent<any>) => {
      if (event.origin !== "http://local.sushishop.fr:8080" && event.data) {
        try {
          const parsedData = JSON.parse(event.data) as IPacmanGameData;
          if (parsedData.score > 0) {
            onFinished?.(parsedData);
          }
        } catch (error) {
          onError?.();
        }
      }
    };
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [onFinished]);

  return (
    <div>
      <FlexBox direction="column" align="center">
        <_LandingPacmanHeaderContainer
          direction="column"
          align="center"
          className="landing-pacman__header"
        >
          <HighlightedTypography
            variant="h4"
            align="center"
            highlightedText={highlightedTitle || ""}
            className="landing-pacman__title"
          >
            {title || ""}
          </HighlightedTypography>
          <Typography
            variant="body"
            align="center"
            className="landing-pacman__description"
          >
            {htmlParse(description + "")}
          </Typography>
        </_LandingPacmanHeaderContainer>
      </FlexBox>
      <_LandingPacmanRoot $aspectRatio={aspectRatio} style={style}>
        <ImageResponsive
          onClick={handlePlay}
          alt=""
          desktop={{
            image: {
              id: poster.desktop,
              fit: ImageFit.COVER,
              quality: 80,
              aspectRatio: aspectRatio,
            },
            imgStyle: {
              overflow: "hidden",
              aspectRatio: aspectRatio,
              width: "100%",
            },
          }}
          mobile={{
            image: {
              id: poster.mobile,
              fit: ImageFit.COVER,
              quality: 100,
              aspectRatio: 3 / 4,
              outputPixelDensities: [1, 2],
            },
            imgStyle: {
              overflow: "hidden",
              aspectRatio: 1,
              width: "100%",
            },
          }}
        />
        <div className="landing-pacman-play" onClick={handlePlay}>
          <Button>{playLabel}</Button>
        </div>
        {url && (
          <iframe
            ref={iframeRef}
            src={url}
            scrolling="yes"
            className={clsx("landing-pacman-iframe", { show: showPlayer })}
          />
        )}
      </_LandingPacmanRoot>
    </div>
  );
};

export default LandingPacman;
